(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1933],{

/***/ 37349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ ACTIVITY_SEARCH_RESULT_FIELDS; },
/* harmony export */   "GF": function() { return /* binding */ PROVIDER_SEARCH_RESULT_FIELDS; },
/* harmony export */   "OS": function() { return /* binding */ JOB_SEARCH_RESULT_FIELDS; },
/* harmony export */   "ZF": function() { return /* binding */ COMMON_CAREGIVER_PROFILE_FIELDS; },
/* harmony export */   "d7": function() { return /* binding */ ARCHIVED_JOB_SEARCH_RESULT_FIELDS; },
/* harmony export */   "ut": function() { return /* binding */ CAREGIVER_SEARCH_RESULT_FIELDS; }
/* harmony export */ });
/* unused harmony export COMMON_CAREGIVER_LISTING_ATTRIBUTES */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68806);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment ChildCareCaregiverQualities on ChildCareCaregiverQualities {\n    comfortableWithPets\n    doesNotSmoke\n    ownTransportation\n    certifiedNursingAssistant\n    certifiedRegisterNurse\n    certifiedTeacher\n    childDevelopmentAssociate\n    cprTrained\n    crn\n    doula\n    earlyChildDevelopmentCoursework\n    earlyChildhoodEducation\n    firstAidTraining\n    nafccCertified\n    specialNeedsCare\n    trustlineCertifiedCalifornia\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment ChildCareCaregiverServices on ChildCareCaregiverServices {\n    carpooling\n    craftAssistance\n    errands\n    groceryShopping\n    laundryAssistance\n    lightHousekeeping\n    mealPreparation\n    swimmingSupervision\n    travel\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment HousekeeperQualities on HousekeeperQualities {\n    comfortableWithPets\n    doesNotSmoke\n    ownTransportation\n    providesEquipment\n    providesSupplies\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment HousekeeperServices on HousekeeperServices {\n    atticCleaning\n    basementCleaning\n    bathroomCleaning\n    cabinetCleaning\n    carpetCleaning\n    changingBedLinens\n    dishes\n    dusting\n    furnitureTreatment\n    generalRoomCleaning\n    greenCleaning\n    houseSitting\n    kitchenCleaning\n    laundry\n    moveOutCleaning\n    organization\n    ovenCleaning\n    packingUnpacking\n    petWasteCleanup\n    plantCare\n    refrigeratorCleaning\n    springSummerCleaning\n    surfacePolishing\n    vacuumingOrMopping\n    wallWashing\n    windowWashing\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment SeniorCareCaregiverQualities on SeniorCareCaregiverQualities {\n    comfortableWithPets\n    doesNotSmoke\n    ownTransportation\n    alzheimersOrDementiaExperience\n    certifiedNursingAssistant\n    cprTrained\n    homeHealthAideExperience\n    hospiceExperience\n    registeredNurse\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment SeniorCareCaregiverServices on SeniorCareCaregiverServices {\n    bathing\n    companionship\n    dementia\n    errands\n    feeding\n    heavyLifting\n    helpStayingPhysicallyActive\n    homeHealth\n    homeModification\n    hospiceServices\n    lightHousekeeping\n    liveInHomeCare\n    mealPreparation\n    medicalManagement\n    medicalTransportation\n    mobilityAssistance\n    personalCare\n    respiteCare\n    specialNeeds\n    specializedCare\n    transportation\n    visitingNurse\n    visitingPhysician\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment TutoringQualities on TutoringQualities {\n    isComfortableWithPets\n    doesNotSmoke\n    ownsTransportation\n    helpsWithArt\n    helpsWithBusiness\n    helpsWithComputers\n    helpsWithDance\n    helpsWithEnglish\n    helpsWithForeignLanguage\n    helpsWithMath\n    helpsWithMusicAndDrama\n    helpsWithMusicalInstruments\n    helpsWithScience\n    helpsWithSpecialEducation\n    helpsWithSportsAndFitness\n    helpsWithTestPrep\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment TutoringServices on TutoringServices {\n    tutorsInCenter\n    tutorsInStudentsHome\n    tutorsInTeachersHome\n    tutorsOnline\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment PetCareQualities on PetCareQualities {\n    doesNotSmoke\n    ownsTransportation\n    caresForAmphibians\n    caresForBirds\n    caresForCats\n    caresForDogs\n    caresForExoticPets\n    caresForFarmAnimals\n    caresForFish\n    caresForHorses\n    caresForMammals\n    caresForOtherPets\n    isBondedAndInsured\n    isNappsCertified\n    isRedCrossPetFirstAidCertified\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment PetCareServices on PetCareServices {\n    administersMedicine\n    boardsOvernight\n    doesDailyFeeding\n    doesHouseSitting\n    doesPetSitting\n    doesPetWalking\n    groomsAnimals\n    retrievesMail\n    trainsDogs\n    transportsPets\n    watersPlants\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment CareGigsQualities on CareGigsQualities {\n    doesNotSmoke\n    isComfortableWithPets\n    ownsTransportation\n    deliversCarsForService\n    doesHouseSitting\n    doesTransportation\n    dropsOffLaundry\n    dropsOffPackages\n    feedsFish\n    handlesEventTickets\n    handlesInvitations\n    helpsAtParties\n    helpsDuringInjury\n    helpsPackOrUnpack\n    plansParties\n    retrievesMail\n    takesOutTrash\n    waitsForHomeServices\n    watersPlants\n    willGiftShopOrWrap\n    willGroceryShop\n    willReturnPurchases\n    willScheduleMovers\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment SpecialNeedsQualities on SpecialNeedsQualities {\n    doesNotSmoke\n    isComfortableWithPets\n    ownsTransportation\n    caresForInfants\n    caresForYouth\n    caresForTeens\n    caresForAdults\n    caresForSeniors\n    caresForADD\n    caresForADHD\n    caresForAspergers\n    caresForAsthma\n    caresForAutism\n    caresForAutismSpectrumDisorder\n    caresForBlindness\n    caresForCancer\n    caresForCeliac\n    caresForCentralAuditoryProcessingDisorder\n    caresForCerebralPalsy\n    caresForCognitiveDisabilities\n    caresForCysticFibrosis\n    caresForDeafness\n    caresForDiabetes\n    caresForDwarfism\n    caresForDyslexia\n    caresForDevelopmentalDelays\n    caresForDownSyndrome\n    caresForEpilepsy\n    caresForFetalAlcoholSyndrome\n    caresForFoodAllergies\n    caresForFragileX\n    caresForHeartDefects\n    caresForHydrocephaly\n    caresForMentalIllness\n    caresForMobilityChallenges\n    caresForMultipleSclerosis\n    caresForMuscularDystrophy\n    caresForObesity\n    caresForOtherNeeds\n    caresForPervasiveDevelopmentalDisorder\n    caresForPolymicrogyria\n    caresForPraderWilli\n    caresForRettSyndrome\n    caresForSeizureDisorder\n    caresForSensoryIntegrationDisorder\n    caresForSickKids\n    caresForSpeechDelay\n    caresForSpinalCordInjury\n    caresForThyroidCondition\n    caresForTouretteSyndrome\n    hasCprTraining\n    hasFirstAidTraining\n    hasSpecialEducationCredentials\n    isCertifiedNursingAssistant\n    isEarlyChildhoodEducator\n    isLicensedPracticingNurse\n    isLicensedVocationalNurse\n    isOccupationalTherapist\n    isPhysicalTherapist\n    isRegisteredNurse\n    isSpeechTherapist\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment SpecialNeedsServices on SpecialNeedsServices {\n    doesAmbulation\n    doesAppliedBehaviorAnalysis\n    doesBathing\n    doesBedBaths\n    doesBladderManagementAssistance\n    doesBloodSugarTesting\n    doesBowelManagementAssistance\n    doesBrushingProtocol\n    doesDressingAssistance\n    doesEpiPenInjections\n    doesErrands\n    doesFeeding\n    doesHousecleaning\n    doesInsulinInjections\n    doesLaundry\n    doesLongDistanceTransportation\n    doesMealPreparation\n    doesMedicalTransportation\n    doesPositiveBehavioralSupport\n    doesRepositioning\n    doesRespiratoryCare\n    doesSeizureAttendance\n    doesStimmingAttendance\n    doesTransferring\n    speaksSignLanguage\n    worksWithAssistiveTechnology\n    worksWithGTubes\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment ChildCareCaregiverQualifications on ChildCareCaregiverQualities {\n    certifiedNursingAssistant\n    cprTrained\n    earlyChildhoodEducation\n    firstAidTraining\n    specialNeedsCare\n    trustlineCertifiedCalifornia\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment SeniorCareCaregiverQualifications on SeniorCareCaregiverQualities {\n    alzheimersOrDementiaExperience\n    certifiedNursingAssistant\n    cprTrained\n    homeHealthAideExperience\n    licensedNurse\n    medicalEquipmentExperience\n    woundCare\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment PetCareCaregiverQualifications on PetCareQualities {\n    isBondedAndInsured\n    isNappsCertified\n    isPSAMemberAndIsInsured\n    isRedCrossPetFirstAidCertified\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment CommonCaregiverListingAttributes on CommonCaregiverProfile {\n    availabilityFrequency\n    bio {\n      title\n      experienceSummary\n      aiAssistedBio\n    }\n    distanceWillingToTravel {\n      unit\n      value\n    }\n    id\n    payRange {\n      hourlyRateFrom {\n        amount\n        currencyCode\n      }\n      hourlyRateTo {\n        amount\n        currencyCode\n      }\n    }\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment SeniorAssistedLivingCenterAttributesFragment on AssistedLivingCenterAttributes {\n    activities {\n      artClasses\n      bbqsOrPicnics\n      birthdayParties\n      brainFitnessOrDakim\n      communitySponsoredActivities\n      continuingLearningPrograms\n      dances\n      fitnessPrograms\n      gardeningClub\n      holidayParties\n      intergenerationalPrograms\n      lightTherapyPrograms\n      liveDanceOrTheater\n      liveMusicalPerformances\n      petFocusPrograms\n      plannedDayTrips\n      religiousServices\n      reminiscencePrograms\n      residentRunActivities\n      scheduledDailyActivities\n      stretchingClasses\n      triviaGames\n      wiiBowling\n    }\n    careServices {\n      alsCare\n      callSystemTwentyFourHours\n      dailyLivingAssistance\n      diabetesCare\n      healthCareProviderCoordination\n      hospiceCare\n      insulinInjections\n      mealPreparationAndService\n      medicationManagement\n      memoryCare\n      mentalWellnessCare\n      mildCognitiveImpairmentCare\n      nursingTwelveToSixteenHours\n      nursingTwentyFourHours\n      parkinsonsCare\n      physicalTherapy\n      preventativeHealthScreenings\n      rehabilitationProgram\n      respiteCare\n      strokeCare\n      supervisionTwentyFourHours\n      transportationArrangement\n      transportationArrangementMedical\n      personalCare\n      medicalPsychUnit\n      skilledNursing\n    }\n    communityTypes {\n      assistedLiving\n      continuingCare\n      independentLiving\n      memoryCare\n      nursingHome\n      retirementCommunity\n    }\n    facilityAmenities {\n      barberOrBeautySalon\n      cafeOrBistro\n      computerCenter\n      diningRoom\n      fitnessRoom\n      gameRoom\n      garden\n      hour24Staff\n      laundryOrDryCleaning\n      library\n      marketOnSite\n      outdoorPatio\n      outdoorSpace\n      privateDiningRooms\n      religiousOrMeditationCenter\n      spaOrJacuzzi\n      swimmingPool\n      wellnessCenter\n    }\n    foodAmenities {\n      allMealsProvided\n      anytimeDining\n      diabetic\n      glutenFree\n      guestMeals\n      halaal\n      kosher\n      lowOrNoSodium\n      noSugar\n      professionalChef\n      roomService\n      someMealsProvided\n      specialDietaryRestrictions\n      vegan\n      vegetarian\n    }\n    onSiteServices {\n      beautician\n      concierge\n      familyEducationAndSupport\n      housekeeping\n      laundryDoneIndividually\n      laundryOrDryCleaning\n      linen\n      moveInCoordination\n    }\n    allowedPets {\n      cat\n      fish\n      dog\n    }\n    rooms {\n      roomAmenities {\n        airConditioning\n        cable\n        fullyFurnished\n        groundFloorOrAccessibleUnits\n        kitchenette\n        privateBathroom\n        telephone\n        wheelchairAccessibleShower\n        wifi\n      }\n      roomTypes {\n        oneBedroom\n        semiPrivateCompanionSuite\n        studio\n        twoBedroom\n      }\n    }\n    supportedLanguages\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  fragment ListingPageCommonCaregiverProfileFields on CaregiverProfiles {\n    commonCaregiverProfile {\n      ...CommonCaregiverListingAttributes\n      qualities {\n        ...ChildCareCaregiverQualifications\n        ...SeniorCareCaregiverQualifications\n        ...PetCareCaregiverQualifications\n      }\n      supportedServices {\n        ...ChildCareCaregiverServices\n        ...PetCareServices\n        ...SeniorCareCaregiverServices\n        ...HousekeeperServices\n      }\n    }\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  fragment CommonCaregiverProfileFields on CaregiverProfiles {\n    commonCaregiverProfile {\n      ...CommonCaregiverListingAttributes\n      qualities @include(if: $profileDetailsPage) {\n        ...SeniorCareCaregiverQualities @include(if: $isSeniorCare)\n        ...ChildCareCaregiverQualities @include(if: $isChildCare)\n        ...HousekeeperQualities @include(if: $isHousekeeping)\n        ...TutoringQualities @include(if: $isTutoring)\n        ...PetCareQualities @include(if: $isPetCare)\n        ...CareGigsQualities @include(if: $isCareGigs)\n        ...SpecialNeedsQualities @include(if: $isSpecialNeeds)\n      }\n      supportedServices @include(if: $profileDetailsPage) {\n        ...SeniorCareCaregiverServices @include(if: $isSeniorCare)\n        ...ChildCareCaregiverServices @include(if: $isChildCare)\n        ...HousekeeperServices @include(if: $isHousekeeping)\n        ...TutoringServices @include(if: $isTutoring)\n        ...PetCareServices @include(if: $isPetCare)\n        ...SpecialNeedsServices @include(if: $isSpecialNeeds)\n      }\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  fragment CaregiverSearchResultFields on SEOSegmentationSearchResultsSuccess {\n    pagination {\n      startIndex\n      endIndex\n      totalNumberOfResults\n      numberOfPages\n      currentPage\n    }\n    caregiverSearchResults {\n      profileURL\n      latestReview {\n        reviewDate\n        rating\n        comment\n        reviewer {\n          displayName\n          imageURL\n        }\n      }\n      caregiver {\n        yearsOfExperience\n        avgReviewRating\n        hasCareCheck\n        numberOfReviews\n        responseTime\n        hiredTimes\n        hiredByCounts {\n          locality {\n            hiredCount\n          }\n        }\n        profiles {\n          ...ListingPageCommonCaregiverProfileFields\n        }\n        member {\n          isPremium\n          age\n          imageURL\n          displayName\n          address {\n            city\n            state\n          }\n        }\n      }\n      caregiverReviews {\n        comment\n        rating\n        reviewDate\n        reviewer {\n          displayName\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  fragment ProviderSearchResultFields on SEOSegmentationSearchResultsSuccess {\n    pagination {\n      startIndex\n      endIndex\n      totalNumberOfResults\n      numberOfPages\n      currentPage\n    }\n    providerSearchResults {\n      seoSegmentationProvider {\n        provider {\n          address {\n            addressLine1\n            city\n            state\n            zip\n          }\n          name\n          avgReviewRating\n          description\n          logo {\n            urlThumbnail\n          }\n        }\n        numberOfReviews\n        providerRate {\n          rate {\n            amount\n            currencyCode\n          }\n          rateDuration\n        }\n        costimate {\n          rate {\n            amount\n            currencyCode\n          }\n          rateDuration\n        }\n      }\n      latestReview {\n        comment\n        rating\n        reviewDate\n        reviewer {\n          displayName\n          imageURL\n        }\n      }\n      profileURL\n      philosophies {\n        academic\n        cooperative\n        outdoorNature\n        developmental\n        faithBased\n        international\n        montessori\n        reggioeEmilia\n        specialNeeds\n        waldorf\n      }\n      schoolTypes {\n        preschool\n        kindergarten\n        inHomeFamily\n        dayCare\n        childCareDayCare\n      }\n      licenseVerified\n      providerReviews {\n        comment\n        rating\n        reviewDate\n        reviewer {\n          displayName\n        }\n      }\n      licenseVerified\n      seniorAssistedLivingCenterAttributes {\n        ...SeniorAssistedLivingCenterAttributesFragment\n      }\n    }\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment JobSearchResultFields on SEOSegmentationSearchResultsSuccess {\n    pagination {\n      startIndex\n      endIndex\n      totalNumberOfResults\n      numberOfPages\n      currentPage\n    }\n    jobSearchResults {\n      seoSegmentationJob {\n        job {\n          title\n          startDate\n          hourlyRateRange {\n            hourlyRateTo {\n              amount\n              currencyCode\n            }\n            hourlyRateFrom {\n              amount\n              currencyCode\n            }\n          }\n        }\n        city\n        state\n        seekerAvatar\n        description\n        type\n      }\n      jobDetailURL\n    }\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment ArchivedJobSearchResultFields on SEOSegmentationSearchResultsSuccess {\n    archivedJobSearchResults {\n      seoSegmentationArchivedJob {\n        description\n        title\n        type\n      }\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment ActivitySearchResultFields on SEOSegmentationSearchResultsSuccess {\n    pagination {\n      startIndex\n      endIndex\n      totalNumberOfResults\n      numberOfPages\n      currentPage\n    }\n    activitySearchResults {\n      seoSegmentationActivity {\n        address {\n          cityState\n          latitude\n          longitude\n        }\n        description\n        discount {\n          price {\n            amount\n            currencyCode\n          }\n          description\n        }\n        maxAgeMonths\n        minAgeMonths\n        participationType\n        photos\n        price {\n          amount\n          currencyCode\n        }\n        providerName\n        reviews {\n          positiveReviews\n          totalReviews\n        }\n        title\n        url\n      }\n    }\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}

var CHILD_CARE_QUALITIES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var CHILD_CARE_SERVICES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var HOUSEKEEPER_QUALITIES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var HOUSEKEEPER_SERVICES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
var SENIOR_CARE_QUALITIES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());
var SENIOR_CARE_SERVICES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5());
var TUTORING_QUALITIES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject6());
var TUTORING_SERVICES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject7());
var PET_CARE_QUALITIES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject8());
var PET_CARE_SERVICES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject9());
var CAREGIGS_QUALITIES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject10());
var SPECIAL_NEEDS_QUALITIES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject11());
var SPECIAL_NEEDS_SERVICES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject12());
var LISTING_PAGE_CHILD_CARE_CAREGIVER_QUALIFICATIONS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject13());
var LISTING_PAGE_SENIOR_CARE_CAREGIVER_QUALIFICATIONS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject14());
var LISTING_PAGE_PET_CARE_CAREGIVER_QUALIFICATIONS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject15());
var COMMON_CAREGIVER_LISTING_ATTRIBUTES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject16());
var SALC_ATTRIBUTES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject17());
var LISTING_PAGE_COMMON_CAREGIVER_PROFILES_FIELDS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject18(), COMMON_CAREGIVER_LISTING_ATTRIBUTES, CHILD_CARE_SERVICES, PET_CARE_SERVICES, SENIOR_CARE_SERVICES, LISTING_PAGE_CHILD_CARE_CAREGIVER_QUALIFICATIONS, LISTING_PAGE_SENIOR_CARE_CAREGIVER_QUALIFICATIONS, LISTING_PAGE_PET_CARE_CAREGIVER_QUALIFICATIONS, HOUSEKEEPER_SERVICES);
var COMMON_CAREGIVER_PROFILE_FIELDS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject19(), CHILD_CARE_QUALITIES, CHILD_CARE_SERVICES, HOUSEKEEPER_QUALITIES, HOUSEKEEPER_SERVICES, SENIOR_CARE_QUALITIES, SENIOR_CARE_SERVICES, TUTORING_QUALITIES, TUTORING_SERVICES, PET_CARE_QUALITIES, PET_CARE_SERVICES, CAREGIGS_QUALITIES, SPECIAL_NEEDS_QUALITIES, SPECIAL_NEEDS_SERVICES, COMMON_CAREGIVER_LISTING_ATTRIBUTES);
var CAREGIVER_SEARCH_RESULT_FIELDS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject20(), LISTING_PAGE_COMMON_CAREGIVER_PROFILES_FIELDS);
var PROVIDER_SEARCH_RESULT_FIELDS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject21(), COMMON_CAREGIVER_LISTING_ATTRIBUTES, SALC_ATTRIBUTES);
var JOB_SEARCH_RESULT_FIELDS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject22());
var ARCHIVED_JOB_SEARCH_RESULT_FIELDS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject23());
var ACTIVITY_SEARCH_RESULT_FIELDS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject24());



/***/ }),

/***/ 36630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ apolloClientQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);



var apolloClientQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(client, query, variables) {
        var ref, queryResponse, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        client.query({
                            query: query,
                            variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, variables),
                            errorPolicy: "all"
                        })
                    ];
                case 1:
                    queryResponse = _state.sent();
                    if (queryResponse.errors && ((ref = queryResponse.errors) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                        throw new Error(queryResponse.errors[0].message);
                    }
                    return [
                        2,
                        {
                            queryResponse: queryResponse,
                            error: null
                        }
                    ];
                case 2:
                    err = _state.sent();
                    return [
                        2,
                        {
                            queryResponse: null,
                            error: err
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function apolloClientQuery(client, query, variables) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 44559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25682);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89728);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5616);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61730);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86492);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(he__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91036);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _utils_dateMonthYearFormat__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42182);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(883);
/* harmony import */ var _contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73739);











var classes = {
    carouselContainer: function(theme) {
        return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            height: "520px"
        }, theme.breakpoints.up("sm"), {
            height: "600px"
        });
    },
    header: function(theme) {
        return {
            fontSize: "h1.fontSize",
            textAlign: "center",
            padding: theme.spacing(4, 0, 5, 0)
        };
    },
    carouselWrapper: {
        display: "flex",
        justifyContent: "center"
    },
    cardsWrapper: function(theme) {
        return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            display: "flex",
            overflow: "hidden",
            justifyContent: "center",
            width: "279px",
            "&::MsOverflowStyle": "none",
            "&::webkitScrollbar": {
                display: "none"
            }
        }, theme.breakpoints.up("sm"), {
            width: "100%"
        });
    },
    card: function(theme) {
        return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            width: "100%",
            display: "flex",
            flexDirection: "column"
        }, theme.breakpoints.up("sm"), {
            "&:not(:last-child)": {
                padding: theme.spacing(0, 4, 0, 0)
            }
        });
    },
    leftArrow: function(theme) {
        return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            padding: theme.spacing(10, 2, 0, 0),
            "& :hover": {
                cursor: "pointer"
            }
        }, theme.breakpoints.up("md"), {
            padding: theme.spacing(20, 2, 0, 0)
        });
    },
    rightArrow: function(theme) {
        return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            padding: theme.spacing(10, 0, 0, 2),
            "& :hover": {
                cursor: "pointer"
            }
        }, theme.breakpoints.up("md"), {
            padding: theme.spacing(20, 0, 0, 2)
        });
    },
    articleHeader: function(theme) {
        return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            padding: theme.spacing(2, 0, 1)
        }, theme.breakpoints.up("sm"), {
            padding: theme.spacing(2, 0, 1.5)
        });
    },
    articleDate: {
        fontSize: "1rem",
        color: "care.grey.400"
    },
    articleContentWrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "end"
    },
    articleDescription: {
        fontSize: ".875rem"
    },
    imgContainer: function(theme) {
        var _obj;
        return _obj = {
            overflow: "hidden",
            height: "186px",
            width: "279px"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.breakpoints.only("sm"), {
            height: "135px",
            width: "200px"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("lg"), {
            height: "243px",
            width: "365px"
        }), _obj;
    },
    imgResponsive: {
        display: "block",
        maxWidth: "100%",
        height: "auto"
    }
};
var ArticleCarousel = function(param) {
    var articles = param.articles;
    var numberOfArticles = articles.length;
    var isMobile = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var isMobileOrSmaller = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var targetValue = isMobileOrSmaller ? "" : "_blank";
    var segmentNameSingular = (0,_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__/* .usePageAttributes */ .l)().segmentNameSingular;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), index = ref[0], setIndex = ref[1];
    var amplitudeDataRotateArticle = {
        feature_name: "Rotate Article Carousel"
    };
    var articleAmplitudeData = {
        feature_name: "Clicked Article Carousel"
    };
    var handleLeftArrow = function() {
        if (index === 0) {
            setIndex(numberOfArticles - 1);
        } else {
            setIndex(index - 1);
        }
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, amplitudeDataRotateArticle);
    };
    var handleRightArrow = function() {
        if (index === numberOfArticles - 1) {
            setIndex(0);
        } else {
            setIndex(index + 1);
        }
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, amplitudeDataRotateArticle);
    };
    var renderArticles = function() {
        var currentCountShown = 0;
        var currentIndex = index;
        var currentArticles = [];
        var maxNumOfArticlesToShow = 5;
        while(currentCountShown < maxNumOfArticlesToShow){
            currentArticles.push(articles[currentIndex]);
            currentIndex += 1;
            currentCountShown += 1;
            if (currentIndex >= numberOfArticles) {
                currentIndex = 0;
            }
        }
        return currentArticles.map(function(param, idx) {
            var title = param.title, createDate = param.createDate, description = param.description, url = param.url, smallImage = param.smallImage, largeImage = param.largeImage;
            var articleDate = createDate !== null ? (0,_utils_dateMonthYearFormat__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                dateTime: createDate,
                useOrdinalDay: true,
                useLongMonth: true,
                useFullDate: true
            }) : "";
            /**
         * @param {string | null} description contains a '<p>' in the beginning of the string
         *  that interfere with the styling layout of the Figma design.
         * @const {string} previewDescription makes a copy of @param {string | null} description without the '<p>'
         */ var previewDescription = description !== null ? description.slice(description.indexOf(">") + 1) : "";
            var imageSourceSmall = (smallImage === null || smallImage === void 0 ? void 0 : smallImage.imageUrl) || "";
            var imageSourceLarge = (largeImage === null || largeImage === void 0 ? void 0 : largeImage.imageUrl) || "";
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                sx: classes.card,
                children: [
                    Boolean(smallImage && largeImage) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        sx: classes.imgContainer,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: url,
                            target: targetValue,
                            onClick: function() {
                                return (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, articleAmplitudeData);
                            },
                            "data-testid": "imageLink",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                component: "img",
                                src: isMobile ? imageSourceSmall : imageSourceLarge,
                                width: isMobile ? "279" : "365",
                                height: isMobile ? "186" : "243",
                                alt: title,
                                sx: classes.imgResponsive
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        href: url,
                        target: targetValue,
                        sx: classes.articleHeader,
                        "data-testid": "article-title-link",
                        onClick: function() {
                            return (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, articleAmplitudeData);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            dangerouslySetInnerHTML: {
                                __html: sanitize_html__WEBPACK_IMPORTED_MODULE_11___default()(he__WEBPACK_IMPORTED_MODULE_2___default().decode(title))
                            },
                            variant: "h2",
                            component: "h3",
                            "data-testid": "articleTitle"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                component: "span",
                                sx: classes.articleDate,
                                "data-testid": "article-date",
                                children: [
                                    articleDate,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                component: "span",
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML: {
                                    __html: sanitize_html__WEBPACK_IMPORTED_MODULE_11___default()(he__WEBPACK_IMPORTED_MODULE_2___default().decode(previewDescription))
                                },
                                sx: classes.articleDescription,
                                "data-testid": "article-description"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "... "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    underline: "always",
                                    href: url,
                                    variant: "body2",
                                    target: targetValue,
                                    onClick: function() {
                                        return (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_3__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, articleAmplitudeData);
                                    },
                                    "data-testid": "readMore",
                                    children: "Read more"
                                })
                            })
                        ]
                    })
                ]
            }, "".concat(url, "-").concat(idx + 1));
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        sx: classes.carouselContainer,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                variant: "h2",
                sx: classes.header,
                children: segmentNameSingular ? "".concat(segmentNameSingular, " Articles") : "Related articles"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                sx: classes.carouselWrapper,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        sx: classes.leftArrow,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            size: "20px",
                            "data-testid": "leftArrow",
                            onClick: handleLeftArrow
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        sx: classes.cardsWrapper,
                        children: renderArticles()
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        sx: classes.rightArrow,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            size: "20px",
                            "data-testid": "rightArrow",
                            onClick: handleRightArrow
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleCarousel);


/***/ }),

/***/ 22284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12963);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);


var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs;
    var schemaJson = {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: []
    };
    var formatJSON = function(breadcrumb, index) {
        return {
            "@type": "ListItem",
            position: index + 1,
            item: {
                "@id": "".concat(breadcrumb.url),
                name: "".concat(breadcrumb.content)
            }
        };
    };
    var createBreadcrumbSchema = function() {
        schemaJson.itemListElement = breadcrumbs.map(function(breadcrumb, index) {
            return formatJSON(breadcrumb, index);
        }) || [];
        return schemaJson;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: breadcrumbs.map(function(param, index) {
                    var content = param.content, url = param.url;
                    return index + 1 !== breadcrumbs.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        component: "a",
                        href: url,
                        variant: "body2",
                        children: content
                    }, content) || index + 1 === breadcrumbs.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        role: "heading",
                        variant: "body2",
                        children: content
                    }, content);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                "data-testid": "breadcrumbListSchema",
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(createBreadcrumbSchema())
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumbs);


/***/ }),

/***/ 70428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5616);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86492);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(he__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91036);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_4__);





var FAQs = function(param) {
    var faqs = param.faqs;
    var schemaJson = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: []
    };
    var formatJSON = function(faq) {
        return {
            "@type": "Question",
            name: "".concat(faq.question),
            acceptedAnswer: {
                "@type": "Answer",
                text: "".concat(faq.answer)
            }
        };
    };
    var createFaqSchema = function() {
        if (faqs.faqList) {
            schemaJson.mainEntity = faqs.faqList.map(function(faq) {
                return formatJSON(faq);
            });
        }
        return schemaJson;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        mt: 5,
        mb: {
            xs: 5,
            md: 10
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "h2",
                color: "primary",
                textAlign: {
                    xs: "center",
                    sm: "left"
                },
                mb: {
                    xs: 3,
                    md: 4
                },
                fontWeight: "400",
                lineHeight: "28px",
                children: faqs.title
            }),
            faqs.faqList && faqs.faqList.map(function(faq) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            variant: "h4",
                            color: "primary",
                            mb: 1.5,
                            children: faq.question
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            role: "dialog",
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML: {
                                __html: sanitize_html__WEBPACK_IMPORTED_MODULE_4___default()(he__WEBPACK_IMPORTED_MODULE_1___default().decode(faq.answer))
                            },
                            sx: function(theme) {
                                return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                    marginBottom: theme.spacing(3),
                                    fontSize: "0.875rem",
                                    fontWeight: 400,
                                    lineHeight: "20px",
                                    color: theme.palette.care.navy[900]
                                }, theme.breakpoints.up("sm"), {
                                    fontSize: "1rem",
                                    lineHeight: "22px",
                                    marginBottom: theme.spacing(4)
                                });
                            }
                        })
                    ]
                }, faq.question);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(createFaqSchema())
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQs);


/***/ }),

/***/ 96301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79967);
/* harmony import */ var _contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73739);





var ref = next_config__WEBPACK_IMPORTED_MODULE_1___default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var PageMeta = function(param) {
    var hrefLangLinks = param.hrefLangLinks, title = param.title, canonicalUrl = param.canonicalUrl, metaDescriptions = param.metaDescriptions, metaKeywords = param.metaKeywords, _paginationPageCount = param.paginationPageCount, paginationPageCount = _paginationPageCount === void 0 ? 1 : _paginationPageCount, _paginationCurrentPage = param.paginationCurrentPage, paginationCurrentPage = _paginationCurrentPage === void 0 ? 1 : _paginationCurrentPage, isCostGuidePage = param.isCostGuidePage, seoSegmentNamePlural = param.seoSegmentNamePlural, isCampsAndActivitiesPage = param.isCampsAndActivitiesPage;
    var ref = (0,_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__/* .usePageAttributes */ .l)(), segmentNamePlural = ref.segmentNamePlural, pageType = ref.pageType, city = ref.city, state = ref.state;
    var logoPath = "".concat(NEXT_PUBLIC_APP_URL, "/img/care-no-tag.jpg");
    var prevLink;
    var nextLink;
    var canonicalPageUrl;
    var newTitle;
    var noindexPage = pageType === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__/* .SEOSegmentationPageType.LOCAL */ .a6.LOCAL && paginationCurrentPage > 1 || isCampsAndActivitiesPage && paginationCurrentPage > 1;
    if (paginationCurrentPage > 1) {
        if (pageType === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__/* .SEOSegmentationPageType.LOCAL */ .a6.LOCAL) {
            newTitle = "Page ".concat(paginationCurrentPage, " - Top ").concat(segmentNamePlural, " in ").concat(city, ", ").concat(state);
        } else {
            newTitle = "Page ".concat(paginationCurrentPage, " - Top ").concat(seoSegmentNamePlural !== null && seoSegmentNamePlural !== void 0 ? seoSegmentNamePlural : segmentNamePlural);
        }
        canonicalPageUrl = "".concat(canonicalUrl, "-page").concat(paginationCurrentPage);
        if (paginationCurrentPage < paginationPageCount) {
            nextLink = "".concat(canonicalUrl, "-page").concat(paginationCurrentPage + 1);
            prevLink = paginationCurrentPage === 2 ? canonicalUrl : "".concat(canonicalUrl, "-page").concat(paginationCurrentPage - 1);
        } else {
            prevLink = "".concat(canonicalUrl);
        }
    } else if (paginationCurrentPage === 1) {
        newTitle = title;
        canonicalPageUrl = canonicalUrl;
        if (paginationPageCount > 1) {
            nextLink = "".concat(canonicalUrl, "-page2");
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            hrefLangLinks && hrefLangLinks.map(function(param) {
                var languageCode = param.languageCode, countryCode = param.countryCode, url = param.url;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "alternate",
                    href: url,
                    hrefLang: "".concat(languageCode, "-").concat(countryCode)
                }, url);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: newTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: metaDescriptions
            }),
            metaKeywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: metaKeywords
            }),
            noindexPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, follow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalPageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "verify-v1",
                content: "zz15lR180u9eCqTfur/9l+bMP75AampYtDEm6OnbkWY="
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: newTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: logoPath
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: metaDescriptions
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Care.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "image/jpeg",
                property: "og:image:type"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "1080",
                property: "og:image:width"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "1080",
                property: "og:image:height"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: "/img/care-no-tag.jpg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "fb:page_id",
                content: "6030284861"
            }),
            isCostGuidePage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "shortcut icon",
                href: "https://www.care.com/img/crcm-favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify({
                        "@context": "http://schema.org",
                        "@type": "Organization",
                        logo: logoPath,
                        name: "Care.com",
                        sameAs: [
                            "https://www.facebook.com/caredotcom/",
                            "https://twitter.com/CareDotCom",
                            "https://www.instagram.com/careorg/",
                            "https://www.linkedin.com/company/care-com", 
                        ],
                        url: "https://www.care.com"
                    })
                }
            }),
            !isCostGuidePage && nextLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextLink
            }),
            !isCostGuidePage && prevLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevLink
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMeta);


/***/ }),

/***/ 6551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5616);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_Pagination__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70872);
/* harmony import */ var _mui_lab_PaginationItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16592);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);






var OffsetPagination = function(param) {
    var pagination = param.pagination, onPageClick = param.onPageClick, segmentId = param.segmentId, pageSelected = param.pageSelected;
    var hasPages = pagination.numberOfPages > 1;
    var hasResults = pagination.numberOfPages > 0;
    var isFirstPage = pageSelected === 1;
    var isLastPage = pageSelected === pagination.numberOfPages;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var handleChangePage = function(event, newPage) {
        event.preventDefault();
        onPageClick(newPage);
        // only show "page" for pages > 1; "/senior-care-page1" should just be "/senior-care"
        var url = newPage === 1 ? segmentId : "".concat(segmentId, "-page").concat(newPage.toString());
        router.push(url, undefined, {
            shallow: true
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        borderTop: function(theme) {
            return hasResults ? "1px solid ".concat(theme.palette.care.grey[300]) : "";
        },
        borderBottom: function(theme) {
            return hasResults ? "1px solid ".concat(theme.palette.care.grey[300]) : "";
        },
        mx: {
            xs: -2,
            sm: 0
        },
        children: [
            hasPages && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                mt: 3,
                mb: 2.25,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Pagination__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    count: pagination.numberOfPages,
                    onChange: handleChangePage,
                    page: pageSelected,
                    renderItem: function(item) {
                        var isNextButton = item.type === "next";
                        var isPrevButton = item.type === "previous";
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_lab_PaginationItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            component: isNextButton && isLastPage || isPrevButton && isFirstPage ? "div" : "a",
                            href: isNextButton && isLastPage || isPrevButton && isFirstPage ? undefined : "".concat(segmentId).concat(item.page === 1 || item.page === 0 ? "" : "-page".concat(item.page)),
                            role: "button"
                        }, item));
                    },
                    sx: {
                        "& .MuiPaginationItem-page": {
                            minWidth: "24px",
                            height: "24px"
                        }
                    }
                })
            }),
            hasResults && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                role: "heading",
                variant: "body3",
                color: "primary",
                mb: 3,
                children: [
                    "Showing ",
                    pagination.startIndex + 1,
                    " - ",
                    pagination.endIndex,
                    " of",
                    " ",
                    pagination.totalNumberOfResults
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OffsetPagination);


/***/ }),

/***/ 8410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _care_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29414);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);




var ref = next_config__WEBPACK_IMPORTED_MODULE_1___default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var SeoGlobalNavbar = function(param) {
    var enrollmentURL = param.enrollmentURL, _internalLinkingMenuContent = param.internalLinkingMenuContent, internalLinkingMenuContent = _internalLinkingMenuContent === void 0 ? undefined : _internalLinkingMenuContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_navigation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        baseURL: NEXT_PUBLIC_APP_URL,
        findJobURL: "/app/vhp/vertical-triage?memberType=sitter",
        logAnalyticsEvent: _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .logOrEnqueueEvent */ .sw,
        joinNowURL: enrollmentURL,
        internalLinkingMenu: {
            internalLinkingMenu: true,
            internalLinkingMenuContent: internalLinkingMenuContent
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoGlobalNavbar);


/***/ }),

/***/ 21058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SeoLinkList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevron.js
var Icon24UtilityChevron = __webpack_require__(68720);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevronUp.js
var Icon24UtilityChevronUp = __webpack_require__(66098);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 3 modules
var Accordion = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(86492);
var he_default = /*#__PURE__*/__webpack_require__.n(he);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ./node_modules/lodash-es/cloneDeepWith.js + 30 modules
var cloneDeepWith = __webpack_require__(23337);
// EXTERNAL MODULE: ./src/__generated__/globalTypes.ts
var globalTypes = __webpack_require__(79967);
;// CONCATENATED MODULE: ./src/utils/smartCapitalize.ts
/**
 * Capitalizes a string excepe small words like 'of' and 'and' for example.
 * @param  {string} str the string to capitalize
 * @return {string} capitalized string
 */ var lower = function(word) {
    return word.toLowerCase();
};
var upper = function(word) {
    return word.substr(0, 1).toUpperCase() + word.substr(1);
};
var smartCapitalize = function(str) {
    var small = "(a|an|and|as|at|but|by|en|for|if|in|of|on|or|the|to|v[.]?|via|vs[.]?)";
    var punct = "([!\"#$%&'()*+,./:;<=>?@[\\\\\\]^_`{|}~-]*)";
    var parts = [];
    var split = /[:.;?!] |(?: |^)["Ò]/g;
    var index = 0;
    while(index < str.length){
        var m = split.exec(str);
        var endIndex = m ? m.index : str.length;
        var part = str.substring(index, endIndex).replace(/\b([A-Za-z][a-z.'Õ]*)\b/g, function(all) {
            return /[A-Za-z]\.[A-Za-z]/.test(all) ? all : upper(all);
        }).replace(new RegExp("\\b".concat(small, "\\b"), "ig"), lower).replace(new RegExp("^".concat(punct).concat(small, "\\b"), "ig"), function(_all, _punct, word) {
            return _punct + upper(word);
        }).replace(new RegExp("\\b".concat(small).concat(punct, "$"), "ig"), upper);
        parts.push(part);
        if (m) {
            parts.push(m[0]);
            index = split.lastIndex;
        } else {
            break;
        }
    }
    return parts.join("").replace(/ V(s?)\. /gi, " v$1. ").replace(/(['Õ])S\b/gi, "$1s").replace(/\b(AT&T|Q&A)\b/gi, function(all) {
        return all.toUpperCase();
    });
};
/* harmony default export */ var utils_smartCapitalize = (smartCapitalize);

// EXTERNAL MODULE: ./src/components/contexts/PageAttributesContext.tsx
var PageAttributesContext = __webpack_require__(73739);
;// CONCATENATED MODULE: ./src/components/ListContainer.tsx



var ListContainer = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        display: "flex",
        flexDirection: "column",
        width: {
            xs: "100%",
            sm: "50%",
            md: "40%"
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/SeoLinkList.tsx











var SeoLinkList = function(param) {
    var seoLinkList = param.seoLinkList, internalLinkingHeadline = param.internalLinkingHeadline, seoSegmentNamePlural = param.seoSegmentNamePlural;
    var ref = (0,react.useState)(false), showMore = ref[0], setShowMore = ref[1];
    var ref1 = (0,PageAttributesContext/* usePageAttributes */.l)(), segmentNameSingular = ref1.segmentNameSingular, segmentNamePlural = ref1.segmentNamePlural, pageType = ref1.pageType;
    var getResourcesTabContentIndex = function(url) {
        var sortOrderIndex = {
            stateSegmentation: 1,
            cityServices: 2,
            stateServices: 3,
            costGuide: 4
        };
        if (url.includes("/cost")) {
            return sortOrderIndex.costGuide;
        }
        if (url.includes("/all-services")) {
            var lastIndex = url.lastIndexOf("/");
            var subString = url.substring(lastIndex, url.length);
            // check if the substring is city-state or state format ('austin-tx' or 'tx')
            if (subString.includes("-")) {
                return sortOrderIndex.cityServices;
            }
            return sortOrderIndex.stateServices;
        }
        return sortOrderIndex.stateSegmentation;
    };
    var sortResourcesTabContent = function(linkLists) {
        return (0,cloneDeepWith/* default */.Z)(linkLists).sort(function(linkListA, linkListB) {
            return getResourcesTabContentIndex(linkListA.url) - getResourcesTabContentIndex(linkListB.url);
        });
    };
    var filterSeoLinkList = function(seoLinkSections) {
        return seoLinkSections.reduce(function(result, seoLink) {
            if (seoLink.id !== globalTypes/* InternalLinkSectionId.ARTICLES */.$z.ARTICLES && !seoLink.title.toLowerCase().includes("jobs") && seoLink.linkList.length > 0) {
                if (seoLink.id === globalTypes/* InternalLinkSectionId.RESOURCES */.$z.RESOURCES) {
                    var linkList = sortResourcesTabContent(seoLink.linkList);
                    result.push({
                        __typename: "SEOSegmentationLinkSection",
                        id: seoLink.id,
                        title: seoLink.title,
                        linkList: linkList
                    });
                    var jobsSeoLink = seoLinkList.find(function(_seoLink) {
                        return _seoLink.title.includes("jobs");
                    });
                    if (jobsSeoLink) {
                        jobsSeoLink.linkList.forEach(function(link) {
                            if (linkList.indexOf(link) === -1) {
                                linkList.push(link);
                            }
                        });
                    }
                } else {
                    result.push(seoLink);
                }
            }
            return result;
        }, []);
    };
    var sortTabs = function(seoLinkSections) {
        var nationalOrLocalPageType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
        var nationalPageTabOrder = Object.freeze({
            RELATED_SERVICES: 1,
            TOP_CITIES: 2,
            RESOURCES: 3,
            NULL_ID: 4
        });
        var localPageTabOrder = Object.freeze({
            RELATED_SERVICES: 2,
            TOP_CITIES: 1,
            RESOURCES: 3,
            NULL_ID: 4
        });
        return (0,cloneDeepWith/* default */.Z)(seoLinkSections).sort(function(linkSectionA, linkSectionB) {
            var sectionAId = linkSectionA.id ? linkSectionA.id.toString() : "NULL_ID";
            var sectionBId = linkSectionB.id ? linkSectionB.id.toString() : "NULL_ID";
            if (nationalOrLocalPageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL) {
                return nationalPageTabOrder[sectionAId] - nationalPageTabOrder[sectionBId];
            }
            return localPageTabOrder[sectionAId] - localPageTabOrder[sectionBId];
        });
    };
    var seoLinks = sortTabs(filterSeoLinkList(seoLinkList), pageType);
    var handleClickShow = function() {
        if (showMore) {
            setShowMore(false);
        } else {
            setShowMore(true);
        }
    };
    var tabHeadline = function(title) {
        if (pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL) {
            if (title.includes("Help")) return "".concat(segmentNameSingular, " in Top Cities");
            if (title.includes("Resources")) return "More Services";
            return title;
        }
        if (title.includes("Related")) return "Sub-categories";
        if (title.includes("Near")) {
            return seoSegmentNamePlural ? "".concat(seoSegmentNamePlural, " in Nearby Cities") : "".concat(segmentNamePlural, " in Nearby Cities");
        }
        if (title.includes("Resources")) return "More Services";
        return title;
    };
    var links = function(linkList) {
        return linkList.map(function(link, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                className: !showMore && index > 19 ? "link-hidden" : "link-visible",
                sx: {
                    "&.link-visible": {
                        cursor: "pointer",
                        lineHeight: "30px"
                    },
                    "&.link-hidden": {
                        visibility: "hidden",
                        maxHeight: "0"
                    }
                },
                href: link.url,
                underline: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "span",
                    variant: "body2",
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: sanitize_html_default()(he_default().decode(utils_smartCapitalize(link.content)))
                    }
                })
            }, "".concat(link.content, "-").concat(index + 1));
        });
    };
    var renderLinkList = function(seoLink) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: {
                            sm: "flex"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListContainer, {
                            children: links(seoLink.linkList).slice(0, 10)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListContainer, {
                            children: links(seoLink.linkList).slice(10, 20)
                        })
                    ]
                }),
                seoLink.linkList.length > 20 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    height: !showMore ? "0px" : "auto",
                    sx: {
                        display: {
                            sm: "flex"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListContainer, {
                            children: links(seoLink.linkList).slice(20, // split links evenly between the two columns
                            20 + (seoLink.linkList.length - 20) / 2)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListContainer, {
                            children: links(seoLink.linkList).slice(20 + (seoLink.linkList.length - 20) / 2)
                        })
                    ]
                }),
                !showMore && seoLink.linkList.length > 20 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    display: "flex",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        onClick: handleClickShow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "span",
                                variant: "body2",
                                color: "text.primary",
                                children: "Show more"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                ml: 1,
                                mt: 0.5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
                                    size: 20
                                })
                            })
                        ]
                    })
                }),
                showMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    display: "flex",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        onClick: handleClickShow,
                        sx: {
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            mt: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "span",
                                variant: "body2",
                                children: "Show less"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                ml: 1,
                                mt: 0.5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevronUp/* default */.Z, {
                                    size: 20
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        md: 10,
        style: {
            margin: "auto"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            disableGutters: true,
            sx: {
                mt: 4
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h3",
                    sx: {
                        fontSize: {
                            xs: "h3.fontSize",
                            sm: "h2.fontSize"
                        },
                        color: "default.main",
                        mb: 1.5
                    },
                    dangerouslySetInnerHTML: {
                        __html: sanitize_html_default()(he_default().decode(internalLinkingHeadline !== null && internalLinkingHeadline !== void 0 ? internalLinkingHeadline : "Additional Services"))
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                    defaultExpanded: true,
                    elevation: 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                        sx: {
                            m: 0,
                            p: 0
                        },
                        children: seoLinks.map(function(seoLink, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                                elevation: 0,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                                        sx: {
                                            width: "fit-content",
                                            p: 0,
                                            "& .MuiIconButton-root": {
                                                mt: 0.5
                                            }
                                        },
                                        expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
                                            color: "#172C42"
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h3",
                                            sx: {
                                                fontSize: {
                                                    xs: "h4.fontSize",
                                                    sm: "h3.fontSize"
                                                },
                                                color: "secondary.main"
                                            },
                                            children: tabHeadline(seoLink.title)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                                        sx: {
                                            m: 0,
                                            p: 0
                                        },
                                        children: renderLinkList(seoLink)
                                    })
                                ]
                            }, "".concat(seoLink.title, "-").concat(index + 1));
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_SeoLinkList = (SeoLinkList);


/***/ }),

/***/ 99207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$I": function() { return /* binding */ SegmentationFiltersContext; },
/* harmony export */   "RZ": function() { return /* binding */ useSegmentationFiltersContext; }
/* harmony export */ });
/* unused harmony export filtersCtx */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable @typescript-eslint/no-unused-vars */ 
var filtersCtx = {
    filters: {
        __typename: "SEOSegmentationFilters",
        location: {
            __typename: "SEOLocationFilters",
            zipcode: "",
            city: "",
            state: null
        }
    },
    setFilters: function(_filters, _reset) {},
    fetchResults: function(_filterVals, _resetPage) {}
};
var SegmentationFiltersContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(filtersCtx);
var useSegmentationFiltersContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SegmentationFiltersContext);
};


/***/ }),

/***/ 19147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useResponsive; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61730);

function useResponsive() {
    var isSmallViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down("sm");
    }); // Mobile Devices
    var isMediumViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.between("sm", "lg");
    }); // Large Mobile and Tablets
    var isLargeViewport = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.up("lg");
    }); // Small and Large Desktops
    return {
        isSmallViewport: isSmallViewport,
        isMediumViewport: isMediumViewport,
        isLargeViewport: isLargeViewport
    };
}



/***/ }),

/***/ 883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sj": function() { return /* binding */ AmplitudeEvent; },
/* harmony export */   "UP": function() { return /* binding */ setPagePropertiesFromData; },
/* harmony export */   "rG": function() { return /* binding */ trackAmplitudeEvent; },
/* harmony export */   "sw": function() { return /* binding */ logOrEnqueueEvent; },
/* harmony export */   "xF": function() { return /* binding */ setDeviceDataFromHeaders; }
/* harmony export */ });
/* unused harmony exports WebPlatform, AMPLITUDE_DATE_FORMAT, AMPLITUDE_TIME_FORMAT, AnalyticsHelper, enqueEvent */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _care_amplitude__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91649);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65885);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);








var WebPlatform;
(function(WebPlatform) {
    WebPlatform["MW"] = "Mobile Web";
    WebPlatform["DT"] = "Desktop Web";
})(WebPlatform || (WebPlatform = {}));
var AmplitudeEvent;
(function(AmplitudeEvent) {
    AmplitudeEvent["applySegmentationFilter"] = "Apply Segmentation Filter";
    AmplitudeEvent["clickOnSegmentationFilter"] = "Click on Segmentation Filter";
    AmplitudeEvent["ctaInteracted"] = "CTA Interacted";
    AmplitudeEvent["providerProfileViewed"] = "Provider Profile Viewed";
    AmplitudeEvent["monetateAssetClicked"] = "Monetate Asset Clicked";
    AmplitudeEvent["seoPageViewed"] = "SEO Page Viewed";
    AmplitudeEvent["testExposure"] = "Test Exposure";
    AmplitudeEvent["jobViewed"] = "Job Viewed";
    AmplitudeEvent["seoFeatureInteracted"] = "SEO Feature Interacted";
    AmplitudeEvent["errorViewed"] = "Error Viewed";
})(AmplitudeEvent || (AmplitudeEvent = {}));
var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()().publicRuntimeConfig;
var AMPLITUDE_DATE_FORMAT = "MMDDYYYY";
var AMPLITUDE_TIME_FORMAT = "hh:mm A";
var initialized = false;
var AnalyticsHelper = /*#__PURE__*/ function() {
    "use strict";
    function AnalyticsHelper() {
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, AnalyticsHelper);
        this.amplitudeEventsQueue = [];
        this.setHeaderData = function(data) {
            _this.headerData = data;
        };
        this.setPageProperties = function(properties) {
            _this.pageProperties = properties;
        };
        this.getHeaderData = function() {
            return _this.headerData;
        };
        this.setEventInQueue = function(event) {
            // @ts-ignore FIX: event is of never type
            _this.amplitudeEventsQueue.push(event);
        };
        this.getEventFromQueue = function() {
            return _this.amplitudeEventsQueue.shift();
        };
        this.getCommonData = function() {
            var cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z();
            var ref = _this.headerData || {}, deviceOs = ref.device_os, isMobile = ref.is_mobile, mobileBrowser = ref.mobile_browser, mobileBrowserVersion = ref.mobile_browser_version;
            var ref1 = _this.pageProperties || {}, seoPageId = ref1.seo_page_id, screenName = ref1.screen_name, screenTemplate = ref1.screen_template, ServiceIdForMember = ref1.service_id_for_member, slots = ref1.slots;
            var czenVisitorId = cookies.get(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CZEN_VISITOR_COOKIE_KEY */ .iN);
            var czenSessionId = cookies.get(_constants__WEBPACK_IMPORTED_MODULE_1__/* .CZEN_SESSION_COOKIE_KEY */ .Ih);
            var screenResolution = "".concat(window.screen.width, " x ").concat(window.screen.height);
            var viewportResolution = "".concat(window.innerWidth, " x ").concat(window.innerHeight);
            var visitorId = czenVisitorId || "VisitorIdNotFound";
            var CZENSessionId = czenSessionId || "SessionIdNotFound";
            var deviceModel = (deviceOs === null || deviceOs === void 0 ? void 0 : deviceOs.split(" ").length) > 1 ? deviceOs === null || deviceOs === void 0 ? void 0 : deviceOs.split(" ")[0] : deviceOs;
            var webPlatform = isMobile === "true" ? WebPlatform.MW : WebPlatform.DT;
            var commonData = {
                czen_session_id: CZENSessionId,
                device_model: deviceModel,
                environment: publicRuntimeConfig.SENTRY_ENV,
                language: navigator.language,
                os_name: mobileBrowser,
                os_version: mobileBrowserVersion,
                referer: document.referrer,
                rendered_by: "seo-mfe",
                screen_name: screenName,
                screen_resolution: screenResolution,
                screen_template: screenTemplate,
                seo_page_id: seoPageId,
                service_id_for_member: ServiceIdForMember,
                slots: slots,
                userAgent: navigator.userAgent,
                viewport_resolution: viewportResolution,
                visitor_id: visitorId,
                web_platform: webPlatform
            };
            return commonData;
        };
        this.logEvent = function(payload) {
            try {
                if (!initialized) {
                    var careAnalyticsConfig = {
                        analyticsEnabled: publicRuntimeConfig.ANALYTICS_ENABLED === "true",
                        key: publicRuntimeConfig.AMPLITUDE_API_KEY,
                        commonData: _this.getCommonData()
                    };
                    (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .init */ .S1)(careAnalyticsConfig);
                    initialized = true;
                    // session id is available with a small delay after amplitude initialization
                    setTimeout(function() {
                        var ref;
                        var amplitudeSessionId = (ref = (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .getInstance */ .s8)()) === null || ref === void 0 ? void 0 : ref.getSessionId();
                        if (amplitudeSessionId) {
                            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .configureScope */ .e)(function(scope) {
                                var user = scope.getUser();
                                scope.setUser((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, user), {
                                    amplitudeSessionId: amplitudeSessionId
                                }));
                            });
                        }
                    });
                }
                var logEventPayload = {
                    name: payload.name,
                    data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload.data)
                };
                (0,_care_amplitude__WEBPACK_IMPORTED_MODULE_4__/* .logEvent */ .Kz)(logEventPayload);
            } catch (e) {
                (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb)(e);
            }
        };
    }
    AnalyticsHelper.init = function init() {
        if (this.analytics === undefined) {
            this.analytics = new AnalyticsHelper();
        }
        return this.analytics;
    };
    return AnalyticsHelper;
}();
var enqueEvent = function(event) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance.setEventInQueue(event);
    return event;
};
var dequeEvent = function() {
    var analyticsInstance = AnalyticsHelper.init();
    return analyticsInstance.getEventFromQueue();
};
var logOrEnqueueEvent = function(param) {
    var name = param.name, data = param.data;
    if (!name || !data) return null;
    var analyticsInstance = AnalyticsHelper.init();
    if (analyticsInstance.getHeaderData() === undefined) {
        return enqueEvent({
            name: name,
            data: data
        });
    }
    return analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.logEvent({
        data: data,
        name: name
    });
};
var trackAmplitudeEvent = function() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    logOrEnqueueEvent({
        name: name,
        data: data
    });
};
var setPagePropertiesFromData = function(properties) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.setPageProperties(properties);
};
var setDeviceDataFromHeaders = function(data) {
    var analyticsInstance = AnalyticsHelper.init();
    analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.setHeaderData(data);
    var eventsPresentInQueue = analyticsInstance.amplitudeEventsQueue.length;
    if (eventsPresentInQueue > 0) {
        // eslint-disable-next-line no-plusplus
        for(var i = 0; i < eventsPresentInQueue; i++){
            var ref = dequeEvent(), eventName = ref.name, eventData = ref.data;
            trackAmplitudeEvent(eventName, eventData);
        }
        return eventsPresentInQueue;
    }
    return data;
};


/***/ }),

/***/ 42182:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/*
 * date conversion to one of the following example formats:
 * Apr 2023
 * April 2023
 * Apr 25, 2023
 * April 25, 2023
 * Apr 25th, 2023
 * April 25th, 2023
 */ // Add postfix like 3rd, 4th, 22nd to the date
var getOrdinalNum = function(n) {
    return n + (n > 0 ? [
        "th",
        "st",
        "nd",
        "rd"
    ][n > 3 && n < 21 || n % 10 > 3 ? 0 : n % 10] : "");
};
var dateMonthYearFormat = function(param) {
    var dateTime = param.dateTime, _useLongMonth = param.useLongMonth, useLongMonth = _useLongMonth === void 0 ? false : _useLongMonth, _useOrdinalDay = param.useOrdinalDay, useOrdinalDay = _useOrdinalDay === void 0 ? false : _useOrdinalDay, _useFullDate = param.useFullDate, useFullDate = _useFullDate === void 0 ? false : _useFullDate;
    var date = new Date(dateTime);
    var dayOftheMonth = useOrdinalDay ? "".concat(getOrdinalNum(date.getUTCDate())) : date.getUTCDate();
    var month = useLongMonth ? date.toLocaleString("en-US", {
        month: "long"
    }) : date.toLocaleString("en-US", {
        month: "short"
    });
    var year = date.getUTCFullYear();
    return useFullDate ? "".concat(month, " ").concat(dayOftheMonth, ", ").concat(year) : "".concat(month, " ").concat(year);
};
/* harmony default export */ __webpack_exports__["Z"] = (dateMonthYearFormat);


/***/ }),

/***/ 85627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HJ": function() { return /* binding */ saveFilters; },
/* harmony export */   "K5": function() { return /* binding */ clearFilters; },
/* harmony export */   "dm": function() { return /* binding */ loadFilters; },
/* harmony export */   "ku": function() { return /* binding */ removeFilter; }
/* harmony export */ });
/* unused harmony export updateFilterField */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);


var loadFilters = function() {
    try {
        var serializedState = localStorage.getItem("filters");
        if (serializedState === null) {
            return null;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return null;
    }
};
var saveFilters = function(filter, __callback) {
    try {
        var storedFilters = localStorage.getItem("filters");
        var filterObj = JSON.parse(storedFilters || "{}");
        filterObj = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, filterObj, filter);
        var serializedState = JSON.stringify(filterObj);
        localStorage.setItem("filters", serializedState);
        if (__callback) {
            __callback();
        }
    } catch (err) {
    // return undefined;
    }
};
var updateFilterField = function(filterName, filterValue) {
    try {
        var storedFilters = localStorage.getItem("filters");
        var filterObj = JSON.parse(storedFilters || "{}");
        set(filterObj, filterName, filterValue);
        var serializedState = JSON.stringify(filterObj);
        localStorage.setItem("filters", serializedState);
    } catch (err) {
    // return undefined;
    }
};
var clearFilters = function() {
    try {
        localStorage.removeItem("filters");
    } catch (err) {
    // return undefined;
    }
};
var removeFilter = function(key) {
    try {
        var storedFilters = localStorage.getItem("filters");
        var filterObj = JSON.parse(storedFilters || "{}");
        delete filterObj[key];
        var serializedState = JSON.stringify(filterObj);
        localStorage.setItem("filters", serializedState);
    } catch (err) {
    // return undefined;
    }
};


/***/ }),

/***/ 93867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _reqHeaderToEntriesObj__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28906);

var getDeviceCharacteristics = function(userAgent, deviceCharHeader) {
    var deviceChar = (0,_reqHeaderToEntriesObj__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(deviceCharHeader, ";");
    if (Object.keys(deviceChar).length === 0) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
            deviceChar = {
                is_mobile: "true"
            };
        } else {
            deviceChar = {
                is_mobile: "false"
            };
        }
    }
    return deviceChar;
};
/* harmony default export */ __webpack_exports__["Z"] = (getDeviceCharacteristics);


/***/ }),

/***/ 21961:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var getQueryParams = function(query) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var local = query.local !== undefined;
    var pageNumber = Number((ref = query.segment) === null || ref === void 0 ? void 0 : ref.toString().split("-page")[1]) || Number((ref1 = query.local) === null || ref1 === void 0 ? void 0 : ref1.toString().split("-page")[1]) || 1;
    var seoSegmentId = local ? "/".concat((ref3 = (ref2 = query.segment) === null || ref2 === void 0 ? void 0 : ref2.toString().split("-page")) === null || ref3 === void 0 ? void 0 : ref3[0], "/").concat((ref5 = (ref4 = query.local) === null || ref4 === void 0 ? void 0 : ref4.toString().split("-page")) === null || ref5 === void 0 ? void 0 : ref5[0]) : "/".concat((ref7 = (ref6 = query.segment) === null || ref6 === void 0 ? void 0 : ref6.toString().split("-page")) === null || ref7 === void 0 ? void 0 : ref7[0]);
    var location = ((ref9 = (ref8 = query.local) === null || ref8 === void 0 ? void 0 : ref8.toString().split("-page")) === null || ref9 === void 0 ? void 0 : ref9[0]) || "";
    var ref11;
    var queryParams = {
        seoSegmentId: seoSegmentId,
        local: local,
        pageNumber: pageNumber,
        location: location,
        testIDToFireTestExposureEvent: typeof query.testIDToFireTestExposureEvent === "string" ? query.testIDToFireTestExposureEvent : (ref11 = (ref10 = query.testIDToFireTestExposureEvent) === null || ref10 === void 0 ? void 0 : ref10[query.testIDToFireTestExposureEvent.length]) !== null && ref11 !== void 0 ? ref11 : ""
    };
    return queryParams;
};
/* harmony default export */ __webpack_exports__["Z"] = (getQueryParams);


/***/ }),

/***/ 7360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getZipcodeFromGeoInfo; }
/* harmony export */ });
var getZipcodeFromGeoInfo = function(userGeoInfo) {
    var match = userGeoInfo === null || userGeoInfo === void 0 ? void 0 : userGeoInfo.match(/zip=(\d{5})/);
    if (match && match[1]) {
        return match[1];
    }
    return "";
};


/***/ }),

/***/ 17411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ mapNavigationMenuContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);


var mapToInternalLinkingMenuLink = function(linklist) {
    return linklist.map(function(link) {
        return {
            label: link.title,
            href: link.urlPath
        };
    });
};
var mapNavigationMenuContent = function(seoNavigationLinkSection) {
    if (!seoNavigationLinkSection) return undefined;
    var navigationLinkSectionDefault = {
        childCareLinks: [],
        seniorCareLinks: [],
        petCareLinks: [],
        housekeepingLinks: [],
        tutoringLinks: [],
        jobsLinks: []
    };
    var mapToSeoNavigationLinkSectionFields = Object.freeze({
        childCareLinks: "childCareLinks",
        seniorCareLinks: "seniorCareLinks",
        petCareLinks: "petCareLinks",
        housekeepingLinks: "housekeepingLinks",
        tutoringLinks: "tutoringLinks",
        jobsLinks: "jobsLinks"
    });
    return Object.entries(seoNavigationLinkSection).reduce(function(currentNavigationLinkSection, entry) {
        var _entry = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(entry, 2), key = _entry[0], value = _entry[1];
        if (key === "__typename") {
            return currentNavigationLinkSection;
        }
        var field = mapToSeoNavigationLinkSectionFields[key];
        var navigationLinkSectionCopy = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, currentNavigationLinkSection);
        var navigationLinkList = mapToInternalLinkingMenuLink(value);
        if (navigationLinkList.length > 0) {
            var allCategoriesLink = {
                label: key === "jobsLinks" ? "See all job categories" : "See all categories",
                href: key === "jobsLinks" ? "/care-directory#jobs" : "/care-directory#care",
                bold: true
            };
            navigationLinkList.push(allCategoriesLink);
        }
        navigationLinkSectionCopy[field] = navigationLinkList;
        return navigationLinkSectionCopy;
    }, navigationLinkSectionDefault);
};


/***/ }),

/***/ 28906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/**
 * Transmutes a key/value pairs object into the format expected by GraphQLEnumType
 * @param  {string} header header string of keys and values
 * @param  {string} delimeter symbol used to separate each key value pair from the next pair
 * @param  {string} valueDelimeter symbol used to separate the key from its value within each pair
 * @return {Object}     Entries object (key/value pairs)
 */ 
var reqHeaderToEntriesObj = function(header) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ";", valueDelimeter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "=";
    if (header === "") return {};
    return header.split(delimiter).reduce(function(accum, curVal) {
        var obj = accum;
        var keyValuePair = curVal.split(valueDelimeter);
        var _keyValuePair = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(keyValuePair, 2), keyValuePairKey = _keyValuePair[0], keyValuePairValue = _keyValuePair[1];
        obj[keyValuePairKey] = keyValuePairValue;
        return obj;
    }, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (reqHeaderToEntriesObj);


/***/ }),

/***/ 75347:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 34017:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 59905:
/***/ (function() {

/* (ignored) */

/***/ })

}]);